import React, { useEffect, useState } from "react";
import { FaFlag } from "react-icons/fa6";
import styles from "./ReportButton.module.css";
import globalStyles from "../../../styles/globalStyles.module.css";
import { createReport } from "../../../services/ReportServices";
import { useAlert } from "../../../context/AlertProvider";
import { reportReasonEnum } from "../../../enums/reportReasonEnum";

export const ReportButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button className={globalStyles.button} onClick={() => setIsOpen(true)}>
        <FaFlag />
      </button>
      <ReportModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />
    </>
  );
};

const ReportModal: React.FC<{
  isOpen: boolean;
  handleClose: () => void;
}> = ({ isOpen, handleClose }) => {
  const [reason, setReason] = useState<reportReasonEnum>();
  const [description, setDescription] = useState<string>("");
  const [currentUrl, setCurrentUrl] = useState<string>("");
  const { showAlert } = useAlert();

  useEffect(() => {
    if (isOpen) {
      document.getElementById("report-modal")?.focus();
      setCurrentUrl(window.location.href);
    }
  }, [isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!reason) {
      showAlert("Please select a reason for reporting.");

      return;
    }
    const report = await createReport({
      page: currentUrl,
      reason: reason,
      description: description,
    });
    if (report) {
      showAlert("report created");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      handleClose();
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className={styles.modalOverlay}
          onClick={handleClose}
          role="presentation"
          aria-hidden="true"
        >
          <div
            id="report-modal"
            className={styles.modal}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            onKeyDown={handleKeyDown}
            tabIndex={-1}
          >
            <h2 id="modal-title">Report Content</h2>
            <p id="modal-description">
              Please provide details about the content you want to report.
            </p>

            <form onSubmit={handleSubmit} className={styles.formContainer}>
              <label htmlFor="page">Page</label>
              <input
                id="page"
                value={currentUrl}
                disabled={true}
                className={globalStyles.input}
              />
              <label htmlFor="reason">Reason:</label>
              <div className={styles.radioButtonContainer}>
                <label>
                  <input
                    type="radio"
                    name="reason"
                    value={reportReasonEnum.abuse}
                    checked={reason === reportReasonEnum.abuse}
                    onChange={(e) => setReason(reportReasonEnum.abuse)}
                    className={styles.radioButton}
                  />
                  Against CGU
                </label>
                <label>
                  <input
                    type="radio"
                    name="reason"
                    value={reportReasonEnum.illegal_activity}
                    checked={reason === reportReasonEnum.illegal_activity}
                    onChange={(e) =>
                      setReason(reportReasonEnum.illegal_activity)
                    }
                    className={styles.radioButton}
                  />
                  Stolen Content
                </label>
                <label>
                  <input
                    type="radio"
                    name="reason"
                    value={reportReasonEnum.other}
                    checked={reason === reportReasonEnum.other}
                    onChange={(e) => setReason(reportReasonEnum.other)}
                    className={styles.radioButton}
                  />
                  Other
                </label>
              </div>

              <label htmlFor="description">Description:</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
                placeholder="Provide more details"
                required
                className={globalStyles.input}
              />

              <button type="submit" className={globalStyles.button}>
                Submit Report
              </button>
              <button
                type="button"
                className={globalStyles.button}
                onClick={handleClose}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
